import React from "react";
import "./ErrorPage.css";

const ErrorName = () => {
  return (
    <div className="container error-page align-middle">
      <img
        src="https://cdn.dribbble.com/users/215588/screenshots/909046/oops.png"
        alt=""
      />
      {/* <div className="error-page-info">
        <h1>404</h1>
        <div className="horizontal-line"></div>
        <h1>Nothing Here To See</h1>
      </div> */}
    </div>
  );
};

export default ErrorName;
